export default __webpack_public_path__ + "static/media/logo-done.af88c5ab.svg";